import { render, staticRenderFns } from "./ListRecruiter.vue?vue&type=template&id=d36d08c8"
import script from "./ListRecruiter.vue?vue&type=script&lang=js"
export * from "./ListRecruiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports